exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./../css/variables.css"), "");

// module
exports.push([module.id, ".loader[data-v-e4d41e38]{text-align:center;margin:20px 0}.no-results[data-v-e4d41e38]{text-align:center;padding:20px 0;font-size:18px;font-family:Oswald,arial,sans-serif;background:var(--aqua)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-e4d41e38","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/CatalogResults.vue
// module id = 501
// module chunks = 0